import * as moment from "moment";

export interface AppointmentModel {
    id: string;
    start: moment.Moment;
    end: moment.Moment;
    clinician: string;
    taskType: string;
    locations: AppointmentLocation[];
}

export interface AppointmentLocation {
    id: string;
    roomName: string;
    address: string;
    notes: string;
}

export const parseAppointmentModel = (appointment: AppointmentModel): AppointmentModel => ({
    ...appointment,
    start: moment(appointment.start),
    end: moment(appointment.end)
});

export enum ClinicLocationTypeName {
    faceToFace = "Face to Face",
    telephone = "Telephone",
    video = "Video",
    mobile = "Mobile"
}

export const ClinicLocationTypes = [
    ClinicLocationTypeName.faceToFace,
    ClinicLocationTypeName.telephone,
    ClinicLocationTypeName.video,
    ClinicLocationTypeName.mobile
];

export const ClinicLocationTypesWithoutMobile = [
    ClinicLocationTypeName.faceToFace,
    ClinicLocationTypeName.telephone,
    ClinicLocationTypeName.video
];

export enum BookingTypeName {
    internalMeeting = "Internal Meeting",
    clientMeeting = "Client Meeting",
    appointmentReservation = "Appointment Reservation",
    annualLeave = "Annual Leave",
    sickness = "Sickness",
    lunch = "Lunch",
    internalTraining = "Internal Training",
    fluClinic = "Flu Clinic",
    otherBillableClinic = "Other Billable Clinic",
    deliveringCustomerTraining = "Delivering Customer Training",
    adminTime = "Admin Time",
    other = "Other"
}

export const BookingTypes = [
    BookingTypeName.internalMeeting,
    BookingTypeName.clientMeeting,
    BookingTypeName.appointmentReservation,
    BookingTypeName.annualLeave,
    BookingTypeName.sickness,
    BookingTypeName.lunch,
    BookingTypeName.internalTraining,
    BookingTypeName.fluClinic,
    BookingTypeName.otherBillableClinic,
    BookingTypeName.deliveringCustomerTraining,
    BookingTypeName.adminTime,
    BookingTypeName.other
];
